module.exports = __webpack_public_path__ + "static/media/teygja_kalfapressa_small.b49be68c.png";